module.exports = __webpack_public_path__ + "static/media/syracuse_univ.19288326.jpg";